<!--师资培训-->
<template>
    <div class="container">
        <div class="wel-box">
            <div class="top-box">
                <homeHead ref="homeHead" />
            </div>
            <div class="course-container">
                <div class="left-menu-container">
                    <tea-train-menu :item-num="this.activeItem"
                                 @change-item="changeItem"/>
                </div>
                <!--统计-->
<!--                <div v-if="activeItem==='1'"  class="right-content-container">-->
<!--                    <tea-train-stat />-->
<!--                </div>-->
                <!--任务-->
                <div v-if="activeItem==='2'"  class="right-content-container">
                    <tea-train-task :course-mode="this.activeMode"
                                    @change-mode="changeMode"/>
                </div>
                <!--课程-->
                <div v-if="activeItem==='3'"  class="right-content-container">
                    <page-train-course title="培训课程"
                                       courseType="1"
                                       :course-mode="this.activeMode"
                                       @change-mode="changeMode"/>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import {timestampToTime} from "@/utils/date";
import homeHead from "@/components/homeHead.vue";
import dataEmpty from "@/components/dataEmpty.vue";
import teaTrainMenu from "@/components/teaTrain/teaTrainMenu.vue";
import teaTrainStat from "@/components/teaTrain/teaTrainStat.vue";
import teaTrainTask from "@/components/teaTrain/teaTrainTask.vue";
import eduUserLesson from "@/components/eduResearch/eduUserLesson.vue";
import pageTrainCourse from "@/components/teaTrain/pageTrainCourse.vue";
import pageCourse from "@/components/resourceCentre/pageCourse.vue";
export default {
    components: {
        pageCourse,
        eduUserLesson,
        dataEmpty,
        homeHead,
        teaTrainMenu,
        teaTrainStat,
        teaTrainTask,
        pageTrainCourse,
    },
    name: "homeEduResearch",
    data() {
        return {
            pageMode:"page",
            detailMode:"detail",
            timestampToTime,
            activePath: "teacherTrainCenter",
            activeItem:"2",
            activeMode:"page",
        }
    },
    computed: {},
    watch: {},
    created() {
    },
    mounted() {
        this.$refs.homeHead.activePath = this.activePath;
    },
    methods: {
        changeItem(item){
            this.activeItem = item;
            this.activeMode = this.pageMode;
        },
        changeMode(mode){
            this.activeMode = mode;
        }
    }
}
</script>
<style scoped>
.container {
    width: 100%;
    height: 100%;
    margin: 0;
    overflow-y: auto!important;
    overflow-x: hidden;
    background-color: #f1f1f1;
}
.wel-box {
    width:100vw;
    height: auto;
    overflow-y: auto!important;
    .top-box{
        display: flex;
        width: 100vw;
        height: 70px;
        background: #3b62f8;
    }
}
.course-container{
    width: 100%;
    height: auto;
    border: 10px;
    box-sizing: border-box;
    display: flex;
}
.left-menu-container{
    width: 200px;
    height: auto;
    padding: 10px;
    box-sizing: border-box;
}
.right-content-container{
    width: calc(100% - 200px);
    height: auto;
    padding: 10px;
    box-sizing: border-box;
}
</style>